import React from 'react';
import {
   Typography,
   FormControlLabel,
   Checkbox
} from '@mui/material';
import styles from './admin.module.css';

/**
 * Reusable Groups Section Component
 * Displays group checkboxes for user assignment
 * 
 * @param {Object} props - Component props
 * @param {Array} props.groups - Currently selected groups
 * @param {Array} props.GSDgroups - Available groups to choose from
 * @param {Function} props.onGroupsChange - Handler for group selection changes
 * @param {boolean} props.disabled - Whether the checkboxes should be disabled
 * @param {number} props.opacity - Opacity value for disabled state (default: 0.7)
 */
const GroupsSection = ({
   groups = [],
   GSDgroups = [],
   onGroupsChange,
   disabled = false,
   opacity = 0.7
}) => {
   return (
      <>
         <Typography variant="subtitle2" className={styles.sectionTitle}>
            Groups
         </Typography>
         <div 
            className={styles.compactPermissionContainer} 
            style={{ 
               opacity: disabled ? opacity : 1,
               pointerEvents: disabled ? 'none' : 'auto'
            }}
         >
            {GSDgroups.map((label, i) => (
               <FormControlLabel 
                  key={i}
                  className={styles.compactCheckbox}
                  disabled={disabled}
                  control={
                     <Checkbox
                        value={label}
                        checked={groups.indexOf(label) !== -1}
                        onChange={onGroupsChange}
                        color="primary"
                        size="small"
                     />
                  }
                  label={label}
                  sx={{ opacity: disabled ? opacity : 1 }}
               />
            ))}
         </div>
      </>
   );
};

export default GroupsSection;
